import classNames from 'classnames';
import { bool, func, string } from 'prop-types';
import { Component } from 'react';

import { Checkbox } from '@alkem/react-ui-checkbox';

import Anchor from 'components/ui/basic/anchor';

import './checkbox.scss';
import AuthFormTooltipError from './tooltip-error';

class AuthFormCheckbox extends Component<{
  id?: string;
  formKey: string;
  checked?: boolean;
  label: string;
  error?: boolean;
  onChange: Function;
  linkUrl?: string;
  linkLabel?: string;
  errorMessage?: string;
}> {
  static propTypes = {
    id: string,
    formKey: string.isRequired,
    checked: bool,
    label: string.isRequired,
    error: bool,
    onChange: func.isRequired,
    linkUrl: string,
    linkLabel: string,
    errorMessage: string,
  };

  static defaultProps = {
    checked: false,
  };

  state = { hasMouse: false };

  onChange = (value) => {
    const { onChange, formKey } = this.props;
    onChange({ formKey, value });
  };

  onMouseEnter = () => {
    this.setState({ hasMouse: true });
  };

  onMouseLeave = () => {
    this.setState({ hasMouse: false });
  };

  render() {
    const {
      id,
      formKey,
      checked,
      label,
      error,
      linkUrl,
      linkLabel,
      errorMessage,
    } = this.props;
    const { hasMouse } = this.state;
    const showTooltip = error && hasMouse;
    return (
      <div
        id={id}
        className={classNames(
          'AuthFormCheckbox alk-flex',
          error && 'AuthFormCheckbox--error',
        )}
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
        data-auth-form-error={`${!!error}`}
      >
        <Checkbox
          id={`auth-form-checkbox-${formKey}`}
          label={label}
          checked={checked}
          onChange={this.onChange}
        />
        {linkUrl && <Anchor href={linkUrl}>{linkLabel || linkUrl}</Anchor>}
        {showTooltip && (
          <AuthFormTooltipError error={error}>
            {errorMessage}
          </AuthFormTooltipError>
        )}
      </div>
    );
  }
}

export default AuthFormCheckbox;
